import Axios from 'axios';
import { getEndpointURL } from './config';
Axios.defaults.withCredentials = true;

const endpointURL = getEndpointURL();
const headers = { 'Content-Type': 'application/json; charset=utf-8' };

const GetProjects = async (searchProject, rowsPerPage, page) => {
    return Axios({
        method: 'POST',
        headers,
        data: { searchProject, rowsPerPage, page },
        url: `${endpointURL}/api/projects/get-projects`
    })
}

const CreateNewProject = async (projectInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: { projectInfor },
        url: `${endpointURL}/api/projects/create-new-project`
    })
}

const UpdateProject = async (projectInfor) => {
    return Axios({
        method: 'POST',
        headers,
        data: { projectInfor },
        url: `${endpointURL}/api/projects/update-project`
    })
}

const DeleteProject = async (projectID) => {
    return Axios({
        method: 'POST',
         headers,
        data: { projectID },
        url: `${endpointURL}/api/projects/delete-project`
    })
}

export {
    GetProjects,
    CreateNewProject,
    UpdateProject,
    DeleteProject,
};
